module.exports = __webpack_public_path__ + "static/media/PPTX.2ba6eac4.svg";